/* eslint-disable perfectionist/sort-objects */

function padZero(number) {
  return number < 10 ? `0${number}` : number
}

export function formatDate(date: Date, format: string) {
  const map = {
    YYYY: date.getFullYear(),
    MM: padZero(date.getMonth() + 1),
    DD: padZero(date.getDate()),
    HH: padZero(date.getHours()),
    mm: padZero(date.getMinutes()),
    ss: padZero(date.getSeconds()),
  }

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (matched) => map[matched])
}

// Example usage:
// const date = new Date()
// const formattedDate = formatDate(date, 'YYYY-MM-DD HH:mm:ss')
// console.log(formattedDate) // Outputs current date and time in the specified format
